import { useBoolState, useIsMounted, useLazyEffect } from '../../../hooks/commonHooks'
import { ProductCardModel } from '../../../server/mpsklad_core/Models/MpCard/ProductCardModel'
import { useApi, useStore } from '../../../hooks/storeHook'
import { ScreenLoader } from '../../../components/ScreenLoader'
import React from 'react'
import { ProductFormBatch } from './ui/productFormBatch'

export const CardsEditPage = () => {
  const {homeNavRequired, mpcardStore: {setSelectedProductCards, selectedRows}} = useStore()
  const isMounted = useIsMounted()
  const [isLoading, , setLoaded] = useBoolState(true)
  const api = useApi()

  useLazyEffect(async () => {
    try {
      const nav = homeNavRequired

      if (!nav?.accountId) {
        throw new Error('accountId отсутствует')
      }

      const accountId: number = nav.accountId

      //TODO: Rework to avoid as
      // eslint-disable-next-line no-type-assertion/no-type-assertion
      const ids = (selectedRows as Array<{id: number}>).map(row => row.id)

      const result: ProductCardModel[] = await Promise.all(
        ids.map(id =>
          api.mpCard.getProductCard({
            integrationType: nav.integrationType,
            productId: id,
            accountId: accountId
          })
        )
      )

      if (isMounted.current) {
        setSelectedProductCards(result)
      }
    } catch (e) {
      console.error('Ошибка загрузки карточек:', e)
    } finally {
      if (isMounted.current) {
        setLoaded()
      }
    }
  }, [])

  if (isLoading) {
    return <ScreenLoader/>
  }

  return <ProductFormBatch/>
}
